// extracted by mini-css-extract-plugin
export default {"recommendationsWrapper":"DogRecommendations-module__recommendationsWrapper--oO7Dc"};